import {
	DELETE_EVENT_REQUEST,
	DELETE_EVENT_REQUEST_CLEAR,
	DELETE_EVENT_REQUEST_FAILED,
	DELETE_EVENT_REQUEST_SUCCESS,
	GET_EVENTS_REQUEST,
	GET_EVENTS_REQUEST_CLEAR,
	GET_EVENTS_REQUEST_FAILED,
	GET_EVENTS_REQUEST_SUCCESS,
	OPEN_EVENT_FORM,
	SAVE_EVENT_REQUEST,
	SAVE_EVENT_REQUEST_CLEAR,
	SAVE_EVENT_REQUEST_FAILED,
	SAVE_EVENT_REQUEST_SUCCESS,
	SET_SELECTED_EVENT,
	SET_SELECTED_EVENTS,
} from "../types"

//get events
export const getEventsRequest = (data) => ({
	type: GET_EVENTS_REQUEST,
	payload: data,
})

export const getEventsRequestSuccess = (data) => ({
	type: GET_EVENTS_REQUEST_SUCCESS,
	payload: data,
})

export const getEventsRequestFailed = (data) => ({
	type: GET_EVENTS_REQUEST_FAILED,
	payload: data,
})

export const getEventsRequestReset = () => ({
	type: GET_EVENTS_REQUEST_CLEAR,
})

//Create events
export const createEventRequest = (data) => ({
	type: SAVE_EVENT_REQUEST,
	payload: data,
})

export const createEventRequestSuccess = (data) => ({
	type: SAVE_EVENT_REQUEST_SUCCESS,
	payload: data,
})

export const createEventRequestFailed = (data) => ({
	type: SAVE_EVENT_REQUEST_FAILED,
	payload: data,
})

export const createEventRequestReset = () => ({
	type: SAVE_EVENT_REQUEST_CLEAR,
})

//delete event
export const deleteEventRequest = (data) => ({
	type: DELETE_EVENT_REQUEST,
	payload: data,
})

export const deleteEventRequestSuccess = (data) => ({
	type: DELETE_EVENT_REQUEST_SUCCESS,
	payload: data,
})

export const deleteEventRequestFailed = (data) => ({
	type: DELETE_EVENT_REQUEST_FAILED,
	payload: data,
})

export const deleteEventRequestReset = () => ({
	type: DELETE_EVENT_REQUEST_CLEAR,
})

//add/remove events
export const setSelectedEvents = (data) => ({
	type: SET_SELECTED_EVENTS,
	payload: data,
})

//edit event single
export const setSelectedEvent = (data) => ({
	type: SET_SELECTED_EVENT,
	payload: data,
})

//handle event form state
export const setEventFormOpen = (data) => ({
	type: OPEN_EVENT_FORM,
	payload: data,
})
